import ProductPage from './ProductPage';

const features = [
  { heading: 'Built for your business', text: 'Use any Android tablet or phone as a face attendance kiosk — no expensive biometric hardware required.', icon: '📷' },
  { heading: 'Save time every day', text: 'AI matches faces in under a second, even with masks or changing lighting conditions.', icon: '⏱' },
  { heading: 'Secure and reliable', text: 'All face data stays encrypted on your account and is never shared with third parties.', icon: '🔒' },
];

export default function Lens() {
  return (
    <ProductPage
      title="Lens"
      subtitle="Touchless facial attendance powered by AI on any Android device camera."
      features={features}
      ctaTitle="Lens"
    />
  );
}
